import { render, staticRenderFns } from "./AdminContrattiDaFirmareView.vue?vue&type=template&id=792e284d&"
import script from "./AdminContrattiDaFirmareView.vue?vue&type=script&lang=ts&"
export * from "./AdminContrattiDaFirmareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports